var exports = {
  "kL": "SidebarShellSkeleton.module__container___M054OU",
  "Kd": "SidebarShellSkeleton.module__containerMobile___M054OU",
  "DF": "SidebarShellSkeleton.module__headerFrame___M054OU",
  "VH": "SidebarShellSkeleton.module__headerFrameBanner___M054OU",
  "kW": "SidebarShellSkeleton.module__headerBanner___M054OU",
  "wx": "SidebarShellSkeleton.module__header___M054OU",
  "D": "SidebarShellSkeleton.module__headerCaret___M054OU",
  "Qs": "SidebarShellSkeleton.module__content___M054OU",
};

module.exports = exports;
